/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why weight by credits?`)
};

const es_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué ponderar por créditos?`)
};

const de_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum nach Credits gewichten?`)
};

const nl_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom wegen naar studiepunten?`)
};

const fr_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi pondérer par crédits ?`)
};

const it_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché ponderare per crediti?`)
};

const pt_br2_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que ponderar por créditos?`)
};

const pt_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque ponderar pelos créditos?`)
};

const ja_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ単位数で加重するのですか?`)
};

const zh_gpa_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要按学分加权？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_q3", locale)
	if (locale === "en") return en_gpa_faq_q3(inputs)
	if (locale === "es") return es_gpa_faq_q3(inputs)
	if (locale === "de") return de_gpa_faq_q3(inputs)
	if (locale === "nl") return nl_gpa_faq_q3(inputs)
	if (locale === "fr") return fr_gpa_faq_q3(inputs)
	if (locale === "it") return it_gpa_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_q3(inputs)
	if (locale === "pt") return pt_gpa_faq_q3(inputs)
	if (locale === "ja") return ja_gpa_faq_q3(inputs)
	return zh_gpa_faq_q3(inputs)
};